<template>
    <div class="select-agent">
      <h1>Choisis un agent IA</h1>
  
      <div class="dashboard-stats" v-if="stats">
        <div class="stat"><strong>Tokens restants :</strong> {{ stats.requestsRemaining }}</div>
        <div class="stat"><strong>Tokens totaux :</strong> {{ stats.requestsTotal }}</div>
        <div class="stat"><strong>Emails collectés :</strong> {{ stats.emailsCollected }}</div>
        <div class="stat"><strong>Utilisateurs :</strong> {{ stats.users }}</div>
      </div>
  
      <div v-if="agents.length === 0" class="no-agents">
        <p>Tu n'as encore aucun agent.</p>
        <button @click="createNewAgent" class="create-agent-button">Créer un nouvel agent</button>
      </div>
  
      <div v-else class="agent-grid">
        <div
          class="agent-card"
          v-for="agent in agents"
          :key="agent.id"
          @click="select(agent)"
        >
          <img v-if="agent.avatar" :src="agent.avatar" alt="avatar" class="avatar" />
          <h2>{{ agent.name }}</h2>
          <p>{{ agent.description || 'Aucune description.' }}</p>
        </div>
        <div class="agent-card new" @click="createNewAgent">
          <h2>+ Créer un nouvel agent</h2>
          <p>Commence avec un agent vide.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { onMounted, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import * as api from '@/services/api.js'
  import Cookies from 'js-cookie'
  
  const router = useRouter()
  const agents = ref([])
  const stats = ref(null)
  
  onMounted(async () => {
    try {
      const token = Cookies.get('token')
      if (!token) return router.push('/sign-in')
  
      agents.value = await api.agents.getAll()
      //stats.value = await api.analytics.getUserStats()
    } catch (err) {
      console.error('Erreur chargement agents ou stats:', err)
      router.push('/sign-in')
    }
  })
  
  function select(agent) {
    Cookies.set('active_agent_id', agent.id)
    router.push('/app')
  }
  
  function createNewAgent() {
    Cookies.remove('active_agent_id')
    router.push('/create-agent')
  }
  </script>
  
  <style scoped>
  .select-agent {
    padding: 60px 20px;
    text-align: center;
    min-height: calc(100vh - 224px);
  }
  
  .dashboard-stats {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .dashboard-stats .stat {
    background: #f3f4f6;
    padding: 10px 20px;
    border-radius: 10px;
    font-size: 1rem;
    color: #374151;
  }
  
  .agent-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 20px;
    margin-top: 30px;
  }
  
  .agent-card {
    padding: 20px;
    background: white;
    border-radius: 12px;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }
  
  .agent-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  }
  
  .agent-card.new {
    border: 2px dashed #4f46e5;
    background: #f3f4f6;
    color: #4f46e5;
  }
  
  .avatar {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 50%;
    margin-bottom: 10px;
  }
  
  .no-agents p {
    margin-bottom: 1rem;
    color: #6b7280;
  }
  
  .create-agent-button {
    background-color: #4f46e5;
    color: white;
    padding: 10px 20px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .create-agent-button:hover {
    background-color: #4338ca;
  }
  </style>
  